import { useCallback } from 'react';

import {
  Container,
  LeftSection,
  RightSection,
  StickyPageHeaderSkeletonWithButtons,
  SupportListLoading,
} from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import AgreementsLoading from '@/_pages/contacts/agreements/loading';
import ApiIntegrationLoading from '@/_pages/contacts/api-integration/loading';
import MarketingCampaignsLoading from '@/_pages/contacts/marketing-campaigns/loading';
import ProfileLoading from '@/_pages/contacts/profile/loading';
import { ProfileRightSectionLoading } from '@/_pages/contacts/profile/right-section';
import { HeaderLoading } from '@/_pages/contacts/shared/components/header-section';
import { contactsSubNav, useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey, renderRightColumn } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'contacts/agreements':
        return <AgreementsLoading />;
      case 'contacts/api-integration':
        return <ApiIntegrationLoading />;
      case 'contacts/marketing-campaigns':
        return <MarketingCampaignsLoading />;
      case 'contacts/support':
        return <SupportListLoading />;
      case 'contacts/profile':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={contactsSubNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection forceFullWidth={matched?.staticData?.isFullWidth}>
          <HeaderLoading />
          {render()}
        </LeftSection>
        {renderRightColumn && (
          <RightSection>
            <ProfileRightSectionLoading />
          </RightSection>
        )}
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
